module.exports = __webpack_public_path__ + "778308c8409920463dd636efeea8a45e.svg";